<template>
  <div style='height:100%;'>
    <span class='actionable' v-if='hasSocialMedia'>
      <img  class="mr-2 h-100" v-if='customerObj.FacebookUrl' src='static/assets/img/SVGIcons/icon-facebook.svg' />
      <img  class="mr-2 h-100" v-if='customerObj.TwitterUrl' src='static/assets/img/SVGIcons/icon-twitter.svg' />
      <img  class="mr-2 h-100" v-if='customerObj.PinterestUrl' src='static/assets/img/SVGIcons/icon-pinterest.svg' />
      <img  class="mr-2 h-100" v-if='customerObj.LinkedInUrl' src='static/assets/img/SVGIcons/icon-linkedin.svg' />      
    </span>
  </div>
</template>

<script>
  export default {
    name: 'socialMedia',
    props: [
        'customerObj'
    ],
    computed:  {
        hasSocialMedia: function (){
            let vm = this;
            let customerObj = vm.customerObj
            if(customerObj.FacebookUrl || customerObj.TwiterUrl || customerObj.PinterestUrl || customerObj.LinkedInUrl) return true
            else return false
        }
    },
    created(){
        let vm = this;
        console.log(vm.customerObj)
    }
  }

</script>

<style lang='scss' scoped>


</style>



// WEBPACK FOOTER //
// src/components/Icons/SocialMedia.vue